import React from 'react';
import {
  Link
} from "react-router-dom";
import config from './../config.js';
import Aside from './common/aside.js';
import Loading from './../../components/loading.js';

export default class ProjectImageDetail extends React.Component {

  constructor(props) {
    super(props);
    console.log(props);
    let user = {};

    if (typeof localStorage.token !== 'undefined' && localStorage.token !== '') {
      user = JSON.parse(localStorage.user);
    }
    const {
      projectid,
      taskid,
      type,
      result
    } = props.match.params;

    let resultText = '';
    if (type === 'vbm') {
      resultText = result === 'qc1' ? '原图' : '颅骨剥离图';
    }
    if (type === 'tbss') {
      resultText = result === 'qc1' ? 'FA图' : 'QC图';
    }

    this.state = {
      page_title: '项目管理 ',
      page_subtitle: type.toUpperCase(),
      user: user,
      projectid: projectid,
      taskid: taskid,
      type: type,
      result: result,
      resultText: resultText,
      taskname: '',
      project: '',
      creator: '',
      loading: true,
      data: ''
    }
    document.title = this.state.page_title + this.state.page_subtitle;


  }

  componentDidMount() {

    this.onInitial();
    this.getProject();

  }

  componentWillReceiveProps(nextProps) {
    const {
      type,
      result
    } = nextProps.match.params;
    let resultText = '';

    if (type === 'vbm') {
      resultText = result === 'qc1' ? '原图' : '颅骨剥离图';
    }
    if (type === 'tbss') {
      resultText = result === 'qc1' ? 'FA图' : 'QC图';
    }

    this.setState({
      page_subtitle: type.toUpperCase(),
      type: type,
      result: result,
      resultText: resultText
    })
  }



  getProject() {
    const me = this;

    let {
      projectid,
      user
    } = me.state;
    const postdata = {
      userid: user.id,
      companyid: user.company_id,
      projectid: projectid,
      Authorization: localStorage.token,
      request: 'project'
    };
    fetch(config.host + '/project/index', {
        method: 'post',
        body: JSON.stringify(postdata)
      })
      .then(res => res.json())
      .then(json => {
        //console.log(json);
        if (json.status === 1) {
          const data = json.data;
          me.setState({
            project: data.project,
            creator: data.creator
          });
        } else {
          me.notify(json.message);
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  }


  onInitial(search) {
    const me = this;

    const {
      projectid,
      taskid,
      type,
      result
    } = me.state;

    const postdata = {
      userid: me.state.user.id,
      projectid: projectid,
      taskid: taskid,
      type: type,
      result: result,
      request: 'query',
      Authorization: localStorage.token
    }

    fetch(config.host + '/project_service/index', {
        method: 'post',
        body: JSON.stringify(postdata)
      })
      .then(res => res.json())
      .then(json => {
        //console.log(json);
        if (json.status === 1) {
          me.setState({
            taskname: json.task_name,
            data: json.data
          });
        }
        me.setState({
          loading: false
        });
      })
      .catch(function(error) {
        console.log(error);
        me.setState({
          loading: false
        });
      });
  }

  render() {
    let image_nc = [];
    let image_pat = [];
    if (this.state.data !== '') {
      const value = this.state.data;
      image_nc = value.imagesnc || value.imagessnc;
      image_pat = value.imagespat || value.imagesspat;
    }

    return (
      <div className="row">
        <Loading display={this.state.loading} />
        <div className="col-10">
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item "><Link className="text-dark " to={`/console/myprojects/project/service_list/${this.state.projectid}/${this.state.type}`}><strong><i className="fa fa-chevron-left"></i> 返回 {this.state.page_subtitle}列表</strong></Link>

                <small className="text-muted"> </small>
              </li>
              <li className="breadcrumb-item active">
                {this.state.project.name}
                [ 创建者: {this.state.creator.realname || this.state.creator.email || this.state.creator.title || this.state.creator.address || this.state.creator.office} ]
              </li>
              <li className="breadcrumb-item " aria-current="page">{this.state.page_subtitle} {this.state.taskname} {this.state.resultText}</li>
            </ol>
          </nav>


            <div className="my-2 py-2"><hr />NC</div>
          {
           image_nc.length && image_nc.map((v,k)=>{
              return(
                <div className="card my-3" key={k}>
                  <a href={v.url} target="_blank"><img className="card-img-top" src={v.url} alt="" /></a>
                  <p className="card-text text-muted p-2">{v.name}</p>

                </div>
                )
            })
            }
            <div className="my-2 py-2"><hr />PAT</div>
            {
            image_pat.length && image_pat.map((v,k)=>{
              return(
                <div className="card my-3" key={k}>
                  <a href={v.url} target="_blank"><img className="card-img-top" src={v.url} alt="" /></a>
                  <p className="card-text text-muted p-2">{v.name}</p>

                </div>
                )
            })
            }
        </div>
        <div className="col-2  pl-0 pr-0">
          <Aside data={this.props.match.params} />
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/apps/console/project_image_detail.js